import { render, staticRenderFns } from "./TestPassageTimer.vue?vue&type=template&id=0c28b658&scoped=true&"
import script from "./TestPassageTimer.vue?vue&type=script&lang=js&"
export * from "./TestPassageTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c28b658",
  null
  
)

export default component.exports